import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/flag/usa.png'
import _imports_1 from '../../assets/images/flag/australia.png'
import _imports_2 from '../../assets/images/flag/spain.png'
import _imports_3 from '../../assets/images/flag/france.png'
import _imports_4 from '../../assets/images/flag/germany.png'
import _imports_5 from '../../assets/images/user/user1.jpg'
import _imports_6 from '../../assets/images/user/user2.jpg'
import _imports_7 from '../../assets/images/user/user3.jpg'
import _imports_8 from '../../assets/images/admin.jpg'


const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<form class=\"search-box d-none\"><div class=\"input-group\"><input type=\"text\" class=\"form-control shadow-none rounded-0 border-0\" placeholder=\"Search here\"><button class=\"default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20\" type=\"button\"> Search <i class=\"flaticon-search-interface-symbol position-relative ms-5 top-1\"></i></button></div></form>", 1)
const _hoisted_7 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_8 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"dropdown language-dropdown\"><button class=\"dropdown-toggle fw-medium position-relative pt-0 pb-0 bg-transparent border-0 transition lh-1\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"flaticon-translate\"></i> ENG </button><div class=\"dropdown-menu rounded-0 bg-white border-0 start-auto end-0\"><div class=\"title d-flex align-items-center justify-content-between\"><span class=\"text-black fw-bold\">Choose Language</span></div><ul class=\"ps-0 mb-0 list-unstyled dropdown-body\"><li class=\"position-relative fw-semibold text-black-emphasis\"><img src=\"" + _imports_0 + "\" width=\"30\" height=\"30\" class=\"rounded-circle position-absolute\" alt=\"flag\"> English <a href=\"#\" class=\"d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none\"></a></li><li class=\"position-relative fw-semibold text-black-emphasis\"><img src=\"" + _imports_1 + "\" width=\"30\" height=\"30\" class=\"rounded-circle position-absolute\" alt=\"flag\"> Australian <a href=\"#\" class=\"d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none\"></a></li><li class=\"position-relative fw-semibold text-black-emphasis\"><img src=\"" + _imports_2 + "\" width=\"30\" height=\"30\" class=\"rounded-circle position-absolute\" alt=\"flag\"> Spanish <a href=\"#\" class=\"d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none\"></a></li><li class=\"position-relative fw-semibold text-black-emphasis\"><img src=\"" + _imports_3 + "\" width=\"30\" height=\"30\" class=\"rounded-circle position-absolute\" alt=\"flag\"> French <a href=\"#\" class=\"d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none\"></a></li><li class=\"position-relative fw-semibold text-black-emphasis\"><img src=\"" + _imports_4 + "\" width=\"30\" height=\"30\" class=\"rounded-circle position-absolute\" alt=\"flag\"> German <a href=\"#\" class=\"d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none\"></a></li></ul></div></div>", 1)
const _hoisted_10 = { class: "dropdown email-dropdown" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-email-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot-badge position-absolute fw-bold rounded-circle text-white bg-success d-inline-block" }, "1")
], -1)
const _hoisted_12 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_13 = { class: "title d-flex align-items-center justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Messages "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "(03)")
], -1)
const _hoisted_15 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  width: "45",
  height: "45",
  class: "rounded-circle position-absolute",
  alt: "user"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode("Jacob Linowiski "),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-5 text-muted fw-normal" }, "35 mins ago")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_20 = { class: "text-muted position-relative" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  width: "45",
  height: "45",
  class: "rounded-circle position-absolute",
  alt: "user"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode("Angela Carter "),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-5 text-muted fw-normal" }, "1 day ago")
], -1)
const _hoisted_23 = { class: "text-muted position-relative" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  width: "45",
  height: "45",
  class: "rounded-circle position-absolute",
  alt: "user"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode("Brad Traversy "),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-5 text-muted fw-normal" }, "2 days ago")
], -1)
const _hoisted_26 = { class: "text-center dropdown-footer" }
const _hoisted_27 = { class: "dropdown notification-dropdown" }
const _hoisted_28 = {
  class: "dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bell-2" }, null, -1)
const _hoisted_30 = { class: "dot-badge position-absolute fw-bold rounded-circle text-white bg-primary d-inline-block" }
const _hoisted_31 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_32 = { class: "title d-flex align-items-center justify-content-between" }
const _hoisted_33 = { class: "text-black fw-bold" }
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = {
  key: 0,
  class: "ps-0 mb-0 list-unstyled dropdown-body"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-chat-centered-dots" })
], -1)
const _hoisted_37 = { class: "d-block text-black-emphasis" }
const _hoisted_38 = {
  key: 0,
  class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10"
}
const _hoisted_39 = { class: "text-center dropdown-footer" }
const _hoisted_40 = { class: "dropdown profile-dropdown" }
const _hoisted_41 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "rounded",
  width: "44",
  height: "44",
  alt: "admin"
}, null, -1)
const _hoisted_43 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_44 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, "Admin", -1)
const _hoisted_46 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_47 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_48 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-2" }, null, -1)
const _hoisted_50 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1)
const _hoisted_52 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }, null, -1)
const _hoisted_54 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: _ctx.isSticky },
    ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_5),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_LightDarkSwtichBtn),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_router_link, {
                  to: "/chat",
                  class: "text-decoration-none link-btn transition fw-medium text-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mark all As Read")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _createTextVNode(" Hey Victor! Could you please... "),
                  _createVNode(_component_router_link, {
                    to: "/chat",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  }),
                  _hoisted_19
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  _createTextVNode(" How are you Victor? Would you please... "),
                  _createVNode(_component_router_link, {
                    to: "/chat",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25,
                  _createTextVNode(" Hey Victor! Could you please... "),
                  _createVNode(_component_router_link, {
                    to: "/chat",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_router_link, {
                  to: "/chat",
                  class: "link-btn text-decoration-none position-relative d-inline-block transition fw-medium fw-medium text-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" View All Messages ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.numberUnreadNotification), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createTextVNode("Notifications "),
                  _createElementVNode("span", _hoisted_34, "(" + _toDisplayString(_ctx.numberUnreadNotification) + ")", 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/notifications",
                  class: "text-decoration-none link-btn transition text-primary fw-medium"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Clear All ")
                  ]),
                  _: 1
                })
              ]),
              (_ctx.notifications && _ctx.notifications.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "text-muted position-relative",
                        key: notification.id
                      }, [
                        _hoisted_36,
                        _createElementVNode("span", _hoisted_37, _toDisplayString(notification.title), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatRelativeTime(notification.createdAt)) + " ", 1),
                        _createVNode(_component_router_link, {
                          to: "/notifications",
                          class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                        }),
                        (notification.status==0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_router_link, {
                  to: "/notifications",
                  class: "link-btn text-decoration-none text-primary position-relative d-inline-block transition fw-medium fw-medium"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" See All Notifications ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("span", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.currentUser.firstName) + " " + _toDisplayString(_ctx.currentUser.lastName), 1),
                _hoisted_45
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("ul", _hoisted_47, [
                _createElementVNode("li", _hoisted_48, [
                  _hoisted_49,
                  _createTextVNode(" My Account "),
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_50, [
                  _hoisted_51,
                  _createTextVNode(" Settings "),
                  _createVNode(_component_router_link, {
                    to: "/profile-settings",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_52, [
                  _hoisted_53,
                  _createTextVNode(" Support "),
                  _createVNode(_component_router_link, {
                    to: "/support-desk-card",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_54, [
                  _hoisted_55,
                  _createTextVNode(" Logout "),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ProcessLogout && _ctx.ProcessLogout(...args))),
                    style: {"cursor":"pointer"},
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}